import * as CryptoJS from 'crypto-js';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { urls } from 'src/app/interfaces/common';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  ipAddress: any;

  constructor(
    private http: HttpClient,
    private serviceMessage: MessageService
  ) {}

  base64Encode(valor: any) {
    return btoa(valor);
  }

  base64Decode(valor: any) {
    return atob(valor);
  }

  buscarLink() {
    const url = urls;
    const urlEncontrada = url.find(
      (element: any) => element._ambienteAbrev === environment.ambienteAbrev
    );
    return urlEncontrada;
  }

  buscarLinkAmbiente(ambiente: any, sistema: any) {
    const url = urls;
    const urlEncontrada = url.find(
      (element: any) => element._ambienteAbrev === ambiente
    );
    return urlEncontrada[`${sistema}`];
  }

  buscarLinkSistema(sistema: any) {
    const busca = this.buscarLink();
    return busca[`${sistema}`];
  }

  decrypt(data: any) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, environment.secretKey);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (error) {
      localStorage.removeItem('access');
      this.exibirMensagem(error);
    }
  }

  encrypt(data: any) {
    try {
      return CryptoJS.AES.encrypt(
        JSON.stringify(data),
        environment.secretKey
      ).toString();
    } catch (error) {
      this.exibirMensagem(error);
    }
  }

  error(error: any) {
    this.exibirMensagem(error);
    if (error === 'Unauthorized') {
      this.exibirAlertaSessao();
      return true;
    } else if (error === 'Unknown Error') {
      this.exibirMensagem('Erro desconhecido!');
      return false;
    } else {
      return false;
    }
  }

  exibirAlerta(severidade: any, detalhe: any, tempo: any) {
    this.limparAlerta();
    let tituloExibicao;
    let tempoExibicao;
    let icon;
    if (tempo === null) {
      tempoExibicao = 4000;
    } else {
      tempoExibicao = tempo;
    }
    switch (severidade) {
      case 'success': {
        tituloExibicao = 'Sucesso';
        icon = "pi pi-check-circle";
        break;
      }
      case 'info': {
        tituloExibicao = 'Informação';
        icon = "pi pi-info-circle";
        break;
      }
      case 'warn': {
        tituloExibicao = 'Alerta';
        icon = "pi pi-exclamation-circle";
        break;
      }
      case 'error': {
        tituloExibicao = 'Erro';
        icon = "pi pi-times-circle";
        break;
      }
      default: {
        tituloExibicao = severidade;
        icon = "pi pi-info-circle";
        break;
      }
    }
    this.serviceMessage.add({
      severity: severidade,
      summary: tituloExibicao,
      detail: detalhe,
      life: tempoExibicao,
      icon: icon,
    });
  }

  exibirAlertaSessao() {
    // this.limparAlerta();
    this.serviceMessage.add({
      key: 'c',
      sticky: true,
      severity: 'warn',
      summary: 'Alerta de Sessão',
      detail: 'Sua sessão expirou! Deseja efetuar o Login novamente?',
    });
  }

  exibirMensagem(msg: any) {
    let ehAdm: boolean;
    ehAdm = true;
    const usuario = this.decrypt(this.isNull(localStorage.getItem('access')));
    if (usuario === '') {
    } else {
      ehAdm = usuario.administrador;
    }
    if (environment.ambiente !== 'Produção' || ehAdm) {
      console.log(msg);
    } else {
    }
  }

  formatarData(valor: any) {
    // Formata yyyy-mm-dd para dd/mm/yyyy
    const ano = valor.slice(0, 4);
    const mes = valor.slice(5, 7);
    const dia = valor.slice(8, 10);
    return dia + '/' + mes + '/' + ano;
  }

  formatarDataSQL(valor: any) {
    // Formata dd/mm/yyyy para yyyy-mm-dd
    const ano = valor.slice(6, 10);
    const mes = valor.slice(3, 5);
    const dia = valor.slice(0, 2);
    return ano + '-' + mes + '-' + dia + ' 12:00:00';
  }

  getIPAddress() {
    // http://api.ipify.org/json
    // http://ip-api.com/json
    // https://ipinfo.io/json
    // https://myexternalip.com/json
    // return this.http.get('https://cors-anywhere.herokuapp.com/http://api.ipify.org/?format=json');
    return this.http.get('http://ip-api.com/json');
  }

  getIPAddress2() {
    if (this.ipAddress) {
      return Promise.resolve(this.ipAddress);
    }
    return new Promise((resolve, reject) => {
      this.http.get(`http://ip-api.com/json`).subscribe(
        (result) => {
          this.exibirMensagem(result);
          this.ipAddress = result;
          resolve(this.ipAddress);
        },
        (error) => {
          this.exibirMensagem(error);
          resolve(error);
        }
      );
    });
  }

  isDesktop() {
    this.exibirMensagem(
      `Resolução: ${window.innerHeight} x ${window.innerWidth}`
    );
    return window.innerWidth >= 640;
  }

  isNull(data: any) {
    if (data) {
      return data;
    } else {
      return '';
    }
  }

  limparAlerta() {
    this.serviceMessage.clear();
  }

  locale() {
    return {
      firstDayOfWeek: 1,
      dayNames: [
        'domingo',
        'segunda-feira',
        'terça-feira',
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        'sábado',
      ],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      monthNamesShort: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez',
      ],
      today: 'Hoje',
      clear: 'Apagar',
    };
  }

  primeiraMaiuscula(texto: string) {
    if (texto) {
      const words = texto.toLowerCase().split(' ');
      for (let i = 0; i < words.length; i++) {
        const w = words[i];
        if (
          w === 'da' ||
          w === 'de' ||
          w === 'do' ||
          w === 'das' ||
          w === 'dos' ||
          w === 'e'
        ) {
          // ignore
        } else {
          words[i] = w[0].toUpperCase() + w.slice(1);
        }
      }
      return words.join(' ');
    }
  }

  sessaoExpirada(mensagem: any) {
    if (mensagem === 'Unauthorized') {
      this.exibirAlertaSessao();
      return true;
    }
  }

  totalRegistros(valor: any) {
    switch (valor) {
      case 0:
        return 'Não foram encontrados registros!';
      case 1:
        return `Foi encontrado ${valor} registro!`;
      default:
        return `Foram encontrados ${valor} registros!`;
    }
  }

  valoresIguais(valor1: any, valor2: any) {
    if (valor1 === valor2) {
      return true;
    } else {
      return false;
    }
  }

  valoresIguaisTelefone(valor1: any, valor2: any) {
    if (
      this.valoresIguais(
        this.isNull(valor1)
          .replace('(', '')
          .replace(')', '')
          .replace(' ', '')
          .replace('-', ''),
        this.isNull(valor2)
          .replace('(', '')
          .replace(')', '')
          .replace(' ', '')
          .replace('-', '')
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  verificarAmbiente() {
    let ambiente = environment.ambienteAbrev;
    if (ambiente === 'PRO') {
      ambiente = '';
    } else {
      ambiente = environment.ambienteAbrev;
    }
    return ambiente;
  }

  verificarDestino() {
    const url = document.URL;
    if (url.search('domdeeducar') > 0) {
      return 'Instituto Dom de Educar';
    } else if (url.search('idea') > 0) {
      return 'IDEA';
    } else if (url.search('unesulbahia') > 0) {
      return 'Unesulbahia';
    } else {
      // UniFTC e Localhost
      return 'UniFTC';
    }
  }

  verificarLogoFooter() {
    switch (this.verificarOrigem()) {
      case 'IDEA':
        return 'assets/layout/images/logo-white.png';
      case 'Instituto Dom de Educar':
        return 'assets/layout/images/logo-white.png';
      case 'Unesulbahia':
        return 'assets/layout/images/logo-white.png';
      default:
        // UniFTC e Localhost
        return 'assets/layout/images/logo-white.png';
    }
  }

  verificarLogoLoginBottom() {
    switch (this.verificarOrigem()) {
      case 'IDEA':
        return '';
      case 'Instituto Dom de Educar':
        return '';
      case 'Unesulbahia':
        return '';
      default:
        // UniFTC e Localhost
        return 'assets/layout/images/uniftc-movimente-seu-futuro.png';
    }
  }

  verificarLogoLoginTop() {
    switch (this.verificarOrigem()) {
      case 'IDEA':
        return 'assets/layout/images/idea-logo.png';
      case 'Instituto Dom de Educar':
        return 'assets/layout/images/instituto-dom-de-educar-logo.png';
      case 'Unesulbahia':
        return 'assets/layout/images/unesulbahia-logo.png';
      default:
        // UniFTC e Localhost
        return 'assets/layout/images/uniftc-branco.png';
    }
  }

  verificarLogoTopbar() {
    switch (this.verificarOrigem()) {
      case 'IDEA':
        return 'assets/layout/images/idea-logo.png';
      case 'Instituto Dom de Educar':
        return 'assets/layout/images/instituto-dom-de-educar-logo.png';
      case 'Unesulbahia':
        return 'assets/layout/images/unesulbahia-logo.png';
      default:
        // UniFTC e Localhost
        return 'assets/layout/images/uniftc-branco.png';
    }
  }

  verificarLogoTopbar2() {
    switch (this.verificarOrigem()) {
      case 'UniFTC':
        return 'assets/layout/images/uniftc-logo-branco.png';
      case 'Localhost':
        return 'assets/layout/images/uniftc-logo-branco.png';
      default:
        // Outros
        return 'assets/layout/images/logo.png';
    }
  }

  verificarOrigem() {
    const url = document.URL;
    if (url.search('domdeeducar') > 0) {
      return 'Instituto Dom de Educar';
    } else if (url.search('ftc') > 0) {
      return 'UniFTC';
    } else if (url.search('idea') > 0) {
      return 'IDEA';
    } else if (url.search('unesulbahia') > 0) {
      return 'Unesulbahia';
    } else {
      return 'Localhost';
    }
    // DOM, FTC, IDEA, IOA, ITC, THINK, UNECE
  }

  verificarPagina() {
    let url = document.URL.replace('https://', '').replace('http://', '');
    url = url.substring(url.search('/') + 1, url.length);
    return url;
  }
}
